/**
 * PROJECT-REVIEW-LAUNCHER.WIDGET
 * Round button of the owl, fixed at the bottom right of the project : opens the review of the project at any time
 */
import { motion } from "framer-motion"
import Tooltip from "@/components/tooltip"
import { useAnimationsDisabled } from "@/utils/animation-mode.utils"

interface Props {
  label: string //Tooltip
  errorsCount: number
  warningsCount: number
  onClick: Function
}

export default function ProjectReviewLauncher(props: Props) {
  const isAnimationsDisabled = useAnimationsDisabled()

  //The badge shows what is left : errors first, then warnings, a check when everything is ready
  const badgeColor: string = props.errorsCount > 0 ? "var(--idt-red)" : props.warningsCount > 0 ? "var(--idt-orange)" : "var(--idt-green)"
  const badgeText: string = props.errorsCount > 0 ? String(props.errorsCount) : props.warningsCount > 0 ? String(props.warningsCount) : "✓"

  return (
    <div style={{ position: "fixed", right: 24, bottom: 24, zIndex: 40 }}>
      <Tooltip text={props.label} position="left">
        <motion.button
          type="button"
          aria-label={props.label}
          initial={isAnimationsDisabled ? false : { scale: 0, rotate: -20 }}
          animate={{ scale: 1, rotate: 0 }}
          whileHover={isAnimationsDisabled ? undefined : { scale: 1.08 }}
          whileTap={isAnimationsDisabled ? undefined : { scale: 0.95 }}
          transition={{ type: "spring", stiffness: 320, damping: 16 }}
          onClick={() => props.onClick()}
          className="flex cursor-pointer"
          style={{
            position: "relative",
            width: 64,
            height: 64,
            borderRadius: "50%",
            alignItems: "center",
            justifyContent: "center",
            border: "none",
            background: "white",
            boxShadow: "0 6px 24px rgba(17, 28, 43, 0.22)",
            overflow: "visible"
          }}>
          <img src={require("@/assets/owl.png")} alt="" style={{ width: 40, height: "auto" }} />
          <span
            className="flex text-sm"
            style={{
              position: "absolute",
              top: -10,
              right: -10,
              minWidth: 22,
              height: 22,
              padding: "0 6px",
              borderRadius: 999,
              alignItems: "center",
              justifyContent: "center",
              fontWeight: 700,
              color: "white",
              background: badgeColor,
              boxShadow: "0 0 0 2px white"
            }}>
            {badgeText}
          </span>
        </motion.button>
      </Tooltip>
    </div>
  )
}
